export enum EHttpMethod {
    POST = 'POST',
    GET = 'GET',
    PATCH = 'PATCH',
    PUT = 'PUT',
    DELETE='DELETE'
}